export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-background-50"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex items-center gap-2 justify-center lg:justify-start mb-4 flex-wrap">
              <span className="inline-flex items-center gap-1 px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-medium">
                <i className="ri-vip-crown-line text-sm"></i>
                蓝光画质
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 bg-accent-100 text-accent-600 rounded-full text-xs font-medium">
                <i className="ri-flashlight-line text-sm"></i>
                超清播放
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 bg-secondary-100 text-secondary-600 rounded-full text-xs font-medium">
                <i className="ri-speed-up-line text-sm"></i>
                不缓冲
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight mb-3 font-heading">
              91免费在线视频
              <span className="block text-primary-600 text-2xl md:text-3xl lg:text-4xl mt-1">
                蓝光画质高清影视免费在线观看
              </span>
            </h1>

            <p className="text-foreground-700 text-base md:text-lg mb-4 font-medium">
              海量高清电影和热门电视剧实时更新，稳定流畅不卡顿
            </p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              专注提供零缓冲观影服务，蓝光画质与超清剧场任你选。平台收录超过五万部电影与电视剧集，涵盖动作、科幻、悬疑、古装、喜剧、动漫等全品类内容。每日实时追踪全球最新影视资源，热门剧集播出后
              <strong className="text-foreground-900">2小时内即上线</strong>。
              全站采用H.265高效编码与P2P CDN加速技术，确保每一位观众都能享受稳定流畅的高清观影体验。
            </p>

            <div className="flex items-center gap-4 md:gap-8 justify-center lg:justify-start mb-8 flex-wrap">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-600 font-heading">5万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-accent-500 font-heading">日更200+</div>
                <div className="text-xs text-foreground-500 mt-1">实时更新</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-secondary-600 font-heading">零缓冲</div>
                <div className="text-xs text-foreground-500 mt-1">流畅播放</div>
              </div>
            </div>

            <div className="flex items-center gap-3 justify-center lg:justify-start flex-wrap">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#cards');
                  if (el) {
                    const top = el.getBoundingClientRect().top + window.scrollY - 72;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#ranking');
                  if (el) {
                    const top = el.getBoundingClientRect().top + window.scrollY - 72;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 border-2 border-background-300 text-foreground-700 rounded-lg font-semibold text-sm hover:border-primary-300 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20projector%20with%20floating%20movie%20scenes%20as%20holograms%2C%20warm%20theater%20lighting%20with%20amber%20and%20coral%20accents%2C%20artistic%20abstract%20cinema%20composition%2C%20luxurious%20golden%20atmosphere%2C%20modern%20minimalist%20style%2C%20dramatic%20light%20beams&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="91免费在线视频 - 蓝光画质高清影视平台"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    parent.classList.add('hidden');
                  }
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}